export default __webpack_public_path__ + "static/media/elevate-wht-banner-1.2dfd0a21.jpg";